import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, CSSProperties } from 'vue';

// #region defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-skeleton-loader',
  props: {
  /**Ширина */
  width: { type: String, default: "0rem"},
  /**Высота */
  height: {type: String, default: "0rem"},
  /**Скругление углов */
  borderRadius: {type: String, default: "0rem"},
},
  setup(__props) {

const props = __props;


// #endregion defineProps

// #region computed
const style = computed<CSSProperties>(() => ({
  width: props.width,
  height: props.height,
  borderRadius: props.borderRadius
}))
// #endregion computed

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tir-pm-skeleton-loader",
    style: _normalizeStyle(style.value)
  }, null, 4))
}
}

})